// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   authUrl: 'https://sfmelb-dev.firebaseapp.com/',
//   firebase: {
//     apiKey: 'AIzaSyCUx2Z5F8HJgF1Fo-Bpj4eHrDjVkGx7MJo',
//     authDomain: 'sfmelb-dev.firebaseapp.com',
//     databaseURL: 'https://sfmelb-dev.firebaseio.com',
//     projectId: 'sfmelb-dev',
//     storageBucket: 'sfmelb-dev.appspot.com',
//     messagingSenderId: '993554544227'
//   },
//   serviceYear: '2024-2025',
//   migrateFrom: '2023-2024',
//   sendRegisterEmail: true
// };

export const environment = {
  production: true,
  authUrl: 'https://sfmelb-prod.firebaseapp.com/',
  firebase: {
    apiKey: 'AIzaSyC0Q0iCMAyLa7_NM4EeeF6bjRCGbnhmVYI',
    authDomain: 'sfmelb-prod.firebaseapp.com',
    databaseURL: 'https://sfmelb-prod.firebaseio.com',
    projectId: 'sfmelb-prod',
    storageBucket: 'sfmelb-prod.appspot.com',
    messagingSenderId: '956573727410'
  },
  serviceYear: '2024-2025',
  migrateFrom: '2023-2024',
  sendRegisterEmail: true
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
